import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Comment({ comment }) {
    const { t } = useTranslation();
    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
            <div
                className="text-[17px] font-semibold pb-2"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {t('Comments from reviewers')}
            </div>
            <div className="mt-2">{comment}</div>
        </div>
    );
}
